const { CrudModel } = require('./crud');
import { post } from './request';
import { setSessionData, clear } from './session';

export class UserModel extends CrudModel {
	constructor() {
		super('admin/user', [
			{ key: "deletionReason", name: "Justificativa", kind: "select", options: [
				{ name: "Funcionário desligado", value: "Funcionário desligado" },
				{ name: "Cadastro incorreto", value: "Cadastro incorreto" },
				{ name: "Cadastro duplicado", value: "Cadastro duplicado" },
				{ name: "Outra (descrição abaixo)", value: "Outra (descrição abaixo)" },
			]},
			{
				key: "currentPassword",
				name: "Senha atual",
				kind: "password",
			},
			{
				key: "passwordConfirmation",
				name: "Confirme a nova senha",
				kind: "password",
			},
		]);
	}

	async login(email: string, password: string) {
		const loginData = await post("auth", "login", {
			email: email,
			password: password,
		});
		await setSessionData(loginData);
		return true;
	}

	async logout() {
		try {
			await post("auth", "logout", {}, true);
		} catch (error) {
			console.error(error);
		}
		await clear();
	}

	async updateProfilePicture(profilePictureUuid: string) {
		return this.executeAction(null, "updateProfilePicture", { profilePictureUuid });
	}

	async updatePassword(data: { password: string, currentPassword: string }) {
		return this.executeAction(null, "updatePassword", data);
	}

	async approveProfessionalRegistration(professionalId: number) {
		return this.executeAction(null, "approveProfessionalRegistration", { professionalUserId: professionalId })
	}
}

export default new UserModel();
